import dbCodes from '../server/dbCodes.js'

type ResellerColliType = {
    id?: string
    name?: string
}

type ResellerLike = {
    settings?: {
        orders?: {
            colliTypes?: ResellerColliType[]
        }
    }
}

const getResellerColliTypes = (resellerOrColliTypes?: ResellerLike | ResellerColliType[]) => {
    if (Array.isArray(resellerOrColliTypes)) {
        return resellerOrColliTypes
    }

    return resellerOrColliTypes?.settings?.orders?.colliTypes || []
}

export function getColliTypeName(colloType: string | null | undefined, resellerOrColliTypes?: ResellerLike | ResellerColliType[]) {
    if (!colloType) {
        return ''
    }

    const resellerColliType = getResellerColliTypes(resellerOrColliTypes).find((type) => type.id === colloType || type.name === colloType)

    return resellerColliType?.name || dbCodes.colloTypes[colloType] || colloType
}
